import naja from "naja";
import Ga from "../Ga";

export default class ShowMoreButton {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('button[data-provide="showMoreButton"]:not([data-smb-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-smb-init', "1");

			item.addEventListener("click", (e) => {
				(new Ga()).onGuidedSearchClick(item);

				naja.makeRequest("POST", item.getAttribute("data-handler"), null, { history: false });
			});
		});
	}
}
